import { render } from "./ArtworkCard.vue?vue&type=template&id=239aef90&scoped=true&ts=true"
import script from "./ArtworkCard.vue?vue&type=script&lang=ts"
export * from "./ArtworkCard.vue?vue&type=script&lang=ts"

import "./ArtworkCard.vue?vue&type=style&index=0&id=239aef90&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239aef90"]])

export default __exports__